import { client } from '@/services/fetch.js'
import { toast } from '@/services/toast.js'
import TranslationProvider from '@/provider/translations.js'

export const getStates = async (workflowList = []) => {

  const states = []
  const transitions = []

  for (const workflow of workflowList) {
    transitions[workflow.key] = []
    try {
      let url = `/compiled-poll/api/workflow/${workflow.key}`
      const response = await client.get(url)

      // Places
      response.data.places.forEach(place => {
        const alreadyExists = states.some(
          existingPlace => existingPlace.name === place.name
        )

        if (!alreadyExists) {
          place.label = place.labels.it
          states.push(place)
        }
      })

      // Transitions
      response.data.transitions.forEach(place => {
        const alreadyExists = transitions[workflow.key].some(
          existingPlace => existingPlace.name === place.name
        )
        if (!alreadyExists) {
          place.label = place.labels.it
          transitions[workflow.key].push(place)
        }
      })
    } catch (error) {
      toast.create(TranslationProvider.getTrans('app.network_error'), 'error')
    }
  }

  return { states, transitions }
}

export const getWorkflows = async (type = 'campaign') => {
  try {
    let url = `/${type}/api/workflow`
    const response = await client.get(url)

    return response.data.map(item => ({
      key: item.key,
      label: item.labels.it
    }))
  } catch (error) {
    toast.create(TranslationProvider.getTrans('app.network_error'), 'error')
  }
}

export const getWorkflow = async (workflow) => {
  try {
    let url = `/campaign/api/workflow/${workflow}`
    return await client.get(url)
  } catch (error) {
    toast.create(TranslationProvider.getTrans('app.network_error'), 'error')
  }
}
